<div
  #scrollable
  class="chat-history flex flex-col gap-4 py-2 overflow-y-scroll"
>
  @for (message of messages; track message.id) {
    <div class="flex gap-2 items-stretch">
      <flx-ai-chat-bubble
        [message]="message"
        [loading]="loading"
        class="w-full"
      />
    </div>
  }

  @if (showAiActionButtons()) {
    <div class="flex items-center ml-8 gap-2">
      @for (action of aiDraftActions; track action) {
        <flx-ai-action-button
          [label]="action.label"
          [flavor]="action.flavor"
          [iconName]="action.icon"
          [disabled]="action.disabled"
          [attr.data-testid]="action.label + '-action-button'"
          (clicked)="action.onAction()"
        />
      }
    </div>
  }

  @if (showPendingMessage()) {
    <flx-ai-pending-message
      [message]="pendingRequestStaticMessage"
      (cancelPendingRequest)="cancelPendingRequest()"
    />
  }
</div>
